import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  stats: {
    display: 'flex',
    gap: theme.spacing(2),
  },

  stat: {
    flex: 1,
    borderRadius: theme.spacing(3),
    background: alpha(theme.palette.common.white, 0.05),
    minHeight: 64,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },

  rank: {
    display: 'inline-flex',
    alignItems: 'baseline',
    gap: theme.spacing(1),
  },
}));
